module.exports = __webpack_public_path__ + "static/play-f8be27f57356af5d286f32bb50efc748.png";